import React from 'react';
import { AlertCircleIcon, CheckIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { plans } from '../data/content';
export function PricingSection() {
  return <section id="pricing" aria-labelledby="precios" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-203" data-mp="1egnuc4uy4ayv">
      <Reveal className="flex flex-col gap-2" data-id="element-204" data-mp="1nakcz9owj59j">
        <span className="inline-flex w-fit items-center gap-2 rounded-lg bg-danger-soft px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-danger" data-id="element-205" data-mp="1n9r1xwiwttll">
          <AlertCircleIcon size={14} data-id="element-206" data-mp="1x8qa7dzrjn82" />
          Oferta de lanzamiento — precio promocional por tiempo limitado
        </span>
        <h2 id="precios" className="font-display text-2xl md:text-3xl font-extrabold uppercase text-ink" data-id="element-207" data-mp="22830y9tr9efx">
          Elegí tu Mega Pack
        </h2>
        <p className="max-w-3xl text-sm md:text-base text-ink-muted" data-id="element-208" data-mp="7tihu1l31qyn">
          Comprando cursos, manuales y recursos por separado te costaría mucho
          más. Durante esta promoción accedés al sistema completo a un precio
          especial.
        </p>
      </Reveal>

      <div className="mt-6 grid gap-4 lg:grid-cols-2 lg:items-start" data-id="element-209" data-mp="1hnvckutoofby">
        {plans.map((plan, i) => <Reveal key={plan.id} delay={i * 0.05} className={`flex h-full flex-col rounded-2xl p-6 ${plan.recommended ? 'border-2 border-accent bg-surface' : 'border border-line bg-surface'}`} data-id="element-210" data-mp="1coilfxvs4m3k" data-mpi={i}>
            {plan.recommended ? <span className="mb-3 inline-flex w-fit items-center gap-1.5 rounded-lg bg-accent px-3 py-1 font-display text-xs font-black uppercase tracking-wide text-canvas" data-id="element-211" data-mp="1vgl75nna2sko">
                <StarIcon size={12} className="fill-canvas" data-id="element-212" data-mp="k1xxz8ifcu5a" />
                Recomendado
              </span> : <span className="mb-3 inline-flex w-fit items-center rounded-lg bg-surface-alt px-3 py-1 font-display text-xs font-bold uppercase tracking-wide text-ink-muted" data-id="element-213" data-mp="fzjeqnaufsdh">
                Mega Pack
              </span>}

            <h3 className={`font-display text-xl md:text-2xl font-extrabold uppercase leading-tight ${plan.recommended ? 'text-accent' : 'text-ink'}`} data-id="element-214" data-mp="mg30r2ot6y2q">
              {plan.name}
            </h3>
            <p className="mt-1.5 text-sm text-ink-muted" data-id="element-215" data-mp="3uweccau2ghq4">{plan.audience}</p>

            <ul className="mt-4 grid gap-1.5 sm:grid-cols-2" data-id="element-216" data-mp="3hqhgo46o7tf">
              {plan.features.map(feature => <li key={feature} className="flex items-start gap-2 text-sm text-ink" data-id="element-217" data-mp="3kz08dapbxlep">
                  <CheckIcon size={14} className="mt-1 flex-shrink-0 text-success" strokeWidth={3} data-id="element-218" data-mp="3py30xvo4hz5s" />
                  <span data-id="element-219" data-mp="3fyc8dzj4hu8c">{feature}</span>
                </li>)}
            </ul>

            <div className="mt-auto pt-5" data-id="element-220" data-mp="2xc4pj6cp7e18">
              <p className="text-xs uppercase tracking-wide text-ink-subtle" data-id="element-221" data-mp="2xd7hzipo5oj9">
                Valor de referencia{' '}
                <span className="line-through" data-id="element-222" data-mp="36brt9yswgvxg">{plan.listPrice}</span>
              </p>
              <p className="mt-1 flex items-baseline gap-2" data-id="element-223" data-mp="369f34ycznf9b">
                <span className={`font-display text-4xl font-black ${plan.recommended ? 'text-accent' : 'text-ink'}`} data-id="element-224" data-mp="31bwyvl9x1o7n">
                  {plan.price}
                </span>
                <span className="text-base font-semibold text-ink-muted" data-id="element-225" data-mp="3p29g5mr1wxaw">
                  ARS
                </span>
              </p>
              <CtaButton href={plan.href} external size="lg" variant={plan.recommended ? 'primary' : 'secondary'} className="mt-4" data-id="element-226" data-mp="3l1qphw0w9xaa">
                {plan.cta}
              </CtaButton>
            </div>
          </Reveal>)}
      </div>
    </section>;
}